import {
  AssigneePickerFragment,
  CompletionTiming,
  Document,
  Frequency,
  Tag,
  TaskStatus,
} from "generated-graphql/graphql";

export type TaskFormType = {
  taskId?: string | null;
  seriesId?: string | null;
  tenantId?: string | null;
  title: string;
  description: string;
  assignee: AssigneePickerFragment | null;
  deadline: Date | null;
  taskStatus: TaskStatus | null;
  frequency: Frequency;
  interval: number;
  reminderDays: { id: string; days: number }[];
  subtasks: { title: string; completed: boolean; id: string }[];
  facilityIds: string[];
  documents: Pick<Document, "id" | "title" | "fileExtension" | "documentType" | "sizeMegabytes">[];
  tags: Pick<Tag, "id" | "name">[];
  links: { url: string; id: string }[];
  watchers: AssigneePickerFragment[];
  completedOn: Date | null;
  completionTiming: CompletionTiming | null;
  completionDeltaDays: number | null;
  isSuggested: boolean;
};

export const TASK_FREQUENCY_ORDER = [
  Frequency.Once,
  Frequency.Weekly,
  Frequency.Monthly,
  Frequency.Quarterly,
  Frequency.Yearly,
];
